import { render, staticRenderFns } from "./RevendaProdutoSection.vue?vue&type=template&id=70cf7548&scoped=true"
import script from "./RevendaProdutoSection.vue?vue&type=script&lang=js"
export * from "./RevendaProdutoSection.vue?vue&type=script&lang=js"
import style0 from "./RevendaProdutoSection.vue?vue&type=style&index=0&id=70cf7548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf7548",
  null
  
)

export default component.exports